import { useContext } from "react";
import { Grid, Stack, Typography } from "@mui/material";
//Import from project
import StudentIcon from "../../Assets/icon_dasboard/graduation.png";
import TeacherIcon from "../../Assets/icon_dasboard/business.png";
import ClassIcon from "../../Assets/icon_dasboard/music.png";
import OweIcon from "../../Assets/icon_dasboard/recurring_owe.png";
import RevenueIcon from "../../Assets/icon_dasboard/recurring.png";
import PartyIcom from "../../Assets/icon_dasboard/flag.png";
import FlagIcon from '@mui/icons-material/Flag';
import PublicForum from "../../Assets/icon_dasboard/public_forum.png";
import "./dashboardstyle.scss";
// import InvoiceImage from "../../Assets/new-dashboard/invoice-img.png";
// import OweImage from "../../Assets/new-dashboard/income-img.png";
import { currencyFormat } from "../../Function/DynamicFn";
import { AuthContext } from "../../Context/AuthContext";
import useGetHeaderCard from "../../Hooks/useGetHeaderCard";

const HeaderCard = () => {
  // Change Language
  const { t } = useContext(AuthContext);

  const { tableData } = useGetHeaderCard();
  // console.log("tableData::", tableData);

  const headerData = [
    {
      cardName: "total_member",
      total: tableData?.totalMember,
      icon: TeacherIcon,
      className: "first",
    },
    {
      cardName: "total_party",
      total: tableData?.totalParty,
      icon: PartyIcom,
      className: "second",
    },
    {
      cardName: "total_loss_member",
      total: tableData?.totalLossOfMember,
      icon: TeacherIcon,
      className: "fourth",
    },
    {
      cardName: "total_candidate",
      total: tableData?.totalCandidates,
      icon: TeacherIcon,
      className: "fifth",
    },
    {
      cardName: "total_public_forum",
      total: tableData?.totalPublicForum,
      icon: PublicForum,
      className: "fourth",
    },
    {
      cardName: "",
      total: currencyFormat(tableData?.totalRevenue),
      icon: OweIcon,
      className: "fifth",
    },
  ];

  return (
    <div className="card-container">
      <Grid container spacing={3}>
        {headerData?.map((data, index) => {
          return (
            <Grid item xs={12} sm={6} md={6} lg={4} xl={4} key={index}>
              <Stack
                direction="row"
                justifyContent="space-between"
                className={`stack-container-${data?.className}`}
              >
                <Stack direction="column" justifyContent="space-between">
                  <Typography className="text-number"> 
                    {data?.total}
                  </Typography>
                  <Typography className="text-title">
                    {t(data?.cardName)}
                  </Typography>
                </Stack>

                <Stack direction="column" justifyContent="center">
                  <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    className="icon-container"
                  >
                    <img
                      src={data?.icon}
                      alt="ThirdShareImg"
                      className="front-icon"
                    />
               
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default HeaderCard;
